'use strict';

import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import { format } from 'date-fns';
import axios from 'axios';
import Calendar from 'rc-calendar';
import cn from 'classnames/bind';

import { appSelectors, appOperations } from '@/state/domains/app';
import { pageOperations, pageSelectors } from '@/state/domains/page';
import { ordersSelectors, ordersOperations } from '@/state/domains/orders';
import { locationListSelectors, locationListOperations } from '@/state/domains/locationList';
import { usersOperations, usersSelectors } from '@/state/domains/users';
import { attemptsOperations, attemptsSelectors } from '@/state/domains/attempts';
import { assignmentsSelectors, assignmentsOperations } from '@/state/domains/assignments';
import { getTomorrowStr, getYesterdayStr } from '@/state/utilities';

import Link from '@/views/common/Link';
import PrevNext from '@/views/common/PrevNext';
import Aside from './Aside';
import MapCont from './MapCont';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//import 'rc-calendar/assets/index.css';
import s from './styles.scss';

const sx = cn.bind(s);

const Main = connect(
	(state, props) => ({
		responsive: appSelectors.getResponsive(state, props),
		urlParams: appSelectors.getUrlParams(state, props),
		pageUrl: appSelectors.getPageUrl(state, props),
		pageUser: usersSelectors.getPageUser(state, props),
		location: appSelectors.getLocation(state, props),
		isPageLoaded: appSelectors.isPageLoaded(state, props),
		username: appSelectors.getPageUsername(state, props),
		attempts: attemptsSelectors.getDailyAttempts(state, props),
		assignments: assignmentsSelectors.getPageUserDayAssignments(state, props),
	}),
	{
		fetchUser: usersOperations.fetchUser,
		fetchUserDailyAttempts: attemptsOperations.fetchUserDailyAttempts,
		fetchUserAttempts: attemptsOperations.fetchUserAttempts,
		fetchAssigned: ordersOperations.fetchAssigned,
		getDayNav: appOperations.getDayNav,
		getAssignments: assignmentsOperations.getAssignments,
		setPageLoaded: appOperations.setPageLoaded,
		setList: locationListOperations.setList,
	}
)(
	class extends React.PureComponent {

		constructor(props) {

			super(props);

			const { location, responsive } = props;

			let listView = true;
			let mapView = responsive.md;
			let pinpoint;
			let mapClasses = [ 'mapCont' ];

			if (location.state) {
				if ('listView' in location.state) {
					listView = location.state.listView;

					if (!responsive.md) {
						mapView = false;
					}
				}
				if ('mapView' in location.state) {
					mapView = location.state.mapView;

					if (!responsive.md) {
						listView = false;
					}
				}
				if ('pinpoint' in location.state) {
					pinpoint = location.state.pinpoint;
				}
			}

			if (!listView) {
				mapClasses.push('full');
			} else if (!mapView) {
				mapClasses.push('hide');
			}

			this.state = {
				listView,
				mapView,
				pinpoint,
				mapClasses,
				loaded: false,
				loading: false,
			};
		}

		componentDidMount() {

			const {
				pageUrl,
				pageUser,
				urlParams,
				isPageLoaded,
				assigned,
				assignments,
				getDayNav,
				fetchUser,
				fetchUserDailyAttempts,
				fetchAssigned,
				setList,
				setPageLoaded,
				getAssignments,
			} = this.props;

			const { username, date } = urlParams;
			const { loading } = this.state;

			if (!isPageLoaded) {

				this.setState({ loading: true });

				const tzOffset = format(new Date(), 'xxx');

				let p1;

				if (!pageUser) {
					p1 = fetchUser(username);
				} else {
					p1 = Promise.resolve();
				}

				const p2 = getDayNav(username, date);
				const p3 = fetchUserDailyAttempts(
					username,
					tzOffset,
					date
				);

				const p4 = getAssignments(username, [ date ]);

				Promise.all([ p1, p2, p3, p4 ]).then(
					([ r1, r2, r3, r4 ]) => {

						let locations;

						if (date in r4.data.assignments) {
							locations = r4.data.assignments[ date ].locations;
						} else {
							locations = [];
						}

						if (r2.success && r3.success && r4.success) {
							setPageLoaded(pageUrl);
							this.setState({ loaded: true });
						}

						this.setState({ loading: false });
						
						setList({
							date,
							locations,
						});
					}
				);

			} else {

				this.setState({ loaded: true });

				if (assignments) {
					setList({
						date,
						locations: assignments.locations,
					});
				}

			}
		}

		render() {

			const {
				responsive,
				urlParams,
				location,
				isPageLoaded,
				pageUser,
				attempts,
				assignments,
				isDragging,
				setPageLoaded,
				fetchUser,
				fetchAssigned,
				fetchUserAttempts,
				fetchUserDailyAttempts,
				postCacheRoutes,
				mobile,
				setList,
			} = this.props;

			const { listView, mapClasses, pinpoint, loading } = this.state;
			const { username, date } = urlParams;
			const google = window.google;

			if (loading) {
				return <div />;
			}

			if (!assignments) {
				return (
					<div className={ s.nothing }>
						<div className={ s.nothingText }>
							Nothing assigned
						</div>
					</div>
				);
			}

			return (
				<>
					{ !!listView && <Aside
						params={ urlParams }
						date={ date }
						username={ username }
					/> }
					{ google && isPageLoaded && <MapCont
						google={ google }
						date={ date }
						username={ username }
						date={ date }
						classNames={ mapClasses }
						pinpoint={ pinpoint }
						mobile={ !responsive.md }
					/> }
				</>
			);
		}
	}
);

export const components = {
	main: Main,
};

export default Main;
